export default __webpack_public_path__ + "static/media/banner.0edd4de0.jpg";